import * as React from 'react';

import OrderLineModel, { ITrackingInfo } from 'src/model/orderline.model';
import PartReturnModel from 'src/model/partReturn.model';
import InvoiceService from 'src/services/invoice/InvoiceService';
import LocaleFormating from 'src/translation/localeFormating';
import { downloadFile } from 'src/utils/downloadHelper';

import './OrdersTableItem.scss';
import { IOrders } from 'src/model/modules/orders.model';
import OrderRow from './OrderRow';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import Downloadloader from 'src/components/common/Downloadloader';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';

function dateStringToNumber(date: string): number {
  return parseInt(date.split('-').join(''), 10);
}

interface IOrdersTableItemProps {
  order: IOrders;
  invoiceId: string;
  invoice: OrderLineModel[];
  trackingNumbers: ITrackingInfo[];
  getTrackingNumbers: (
    lineNumber: number,
    orderDate: number,
    orderNumber: number,
    orderDetailStatus: string
  ) => void;
  handleModalClicked: (
    invoices: { [key: string]: OrderLineModel[] },
    status: string,
    poNumber: string,
    date: string,
    part: PartReturnModel
  ) => void;
  getInvoicePreview: (invoiceNumber: string, orderNumber: string) => void;
  loaderStatus: boolean;
  t?: any;
}

interface IOrdersTableItemState {
  hasInvoicesToReturn: boolean;
  loaderStatus: boolean;
  hideShowPdfError: boolean;
}

class OrdersTableItem extends React.Component<
  IOrdersTableItemProps,
  IOrdersTableItemState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      hasInvoicesToReturn: false,
      loaderStatus: false,
      hideShowPdfError: false
    };
  }

  /* 
    getInvoicePreview
   */
  // private getInvoicePreview = (invoiceNumber: string, orderNumber: string) => {
  //   InvoiceService.downloadInvoiceByOrderno(invoiceNumber, orderNumber).then(
  //     (response: any) => {
  //       downloadFile(
  //         response.data,
  //         `invoice-${invoiceNumber}-${LocaleFormating.getNowDate('short')}.pdf`
  //       );
  //     }
  //   );
  // };

  private getInvoicePreview = (invoiceNumber: string, orderNumber: string) => {
    // console.log("Invoice Clicked Here");
    this.setState({
      loaderStatus: true,
      hideShowPdfError: false
    });
    /*window.scrollTo({ top: 0, behavior: 'smooth' });*/
    InvoiceService.downloadInvoiceByOrderno(invoiceNumber, orderNumber)
      .then((response: any) => {
        downloadFile(
          response.data,
          `invoice-${invoiceNumber}-${LocaleFormating.getNowDate('short')}.pdf`
        );
        this.setState({
          hideShowPdfError: false,
          loaderStatus: false
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          hideShowPdfError: true,
          loaderStatus: false
        });
        // window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  };

  public componentDidMount() {
    const { order } = this.props;

    for (const line of this.props.invoice) {
      // this.props.getTrackingNumbers(
      //   line.lineNumber,
      //   dateStringToNumber(order.orderDate),
      //   order.orderNumber,
      //   line.orderDetailStatus
      // );
      if (line.invoiceNumber && !line.specialOrder) {
        this.setState({
          hasInvoicesToReturn: true
        });
      }
    }
  }

  public render() {
    const { order } = this.props;
    const { t } = this.props;

    return (
      <React.Fragment>
        {this.state.loaderStatus ? <Downloadloader /> : ''}
        {/* Download message error show here */}
        {this.state.hideShowPdfError ? (
          <span>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    this.setState({
                      hideShowPdfError: false
                    });
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                <div className="error-message-to-show">
                  {i18n.t('invoices.downloaderror')}
                </div>
              </div>
            </Alert>
            <br />
          </span>
        ) : (
          ''
        )}
        <table className="rp-orders-table-item">
          <tbody>
            <tr>
              <td
                className={`rp-orders-table-item--invoice ${order.creditOrder &&
                  'credit-invoice'}`}
              >
                {this.props.invoiceId == null ||
                this.props.invoiceId === 'null' ||
                this.props.invoiceId === 'backorder' ||
                this.props.invoiceId === '0' ? (
                  ''
                ) : (
                  <React.Fragment>
                    <span className="rpds-ticket" />
                    <div
                      className={`rp-orders-table-item--invoice-text ${
                        order.creditOrder ? 'credit-invoice' : 'link'
                      }`}
                      onClick={() => {
                        this.getInvoicePreview(
                          this.props.invoiceId,
                          `${order.orderNumber}`
                        );
                      }}
                    >
                      {`${order.creditOrder ? 'Credit' : 'Invoice'} ${
                        this.props.invoiceId
                      }`}
                    </div>
                  </React.Fragment>
                )}
              </td>
            </tr>
            <tr className="rp-orders-table-item--table-row">
              <td>
                <table className="rp-orders-table-item--table-row-head">
                  <tr>
                    <td className="rp-orders-table-item--special-order" />
                    <td className="rp-orders-table-item--table-column rp-part-number-area">
                      {t('myOrders.searchByKeys.partNumber')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-description-area">
                      {t('myOrders.description')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-qty-area">
                      {t('myOrders.qty')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-price-area">
                      {t('myOrders.price')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-amount-area">
                      {t('myOrders.amount')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-ship-from-area">
                      {t('myOrders.shippedFrom')}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-shipment-marking-area">
                      {t('myOrders.shipmentMakring')}
                    </td>
                    {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
                      <td className="rp-orders-table-item--table-column rp-delivery-date">
                        {t('myOrders.deliveryDate')}
                      </td>
                    ) : (
                      <td className="rp-orders-table-item--table-column rp-shipment-info">
                        {t('myOrders.shipmentInfo')}
                      </td>
                    )}
                    <td className="rp-orders-table-item--table-column rp-track-no-area">
                      {order.status === 'Backordered' &&
                      (this.props.invoiceId == null ||
                        this.props.invoiceId === 'null' ||
                        this.props.invoiceId === 'backorder' ||
                        this.props.invoiceId === '0')
                        ? ''
                        : `${i18n.t('myOrders.trackNo')}`}
                    </td>
                    <td className="rp-orders-table-item--table-column rp-shipment-orderdetails-status">
                      {t('myOrders.status')}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            {this.props.invoice.map((part, idx) => (
              <OrderRow
                key={idx}
                partId={`${part.orderNumber}-${part.invoiceNumber}-${part.lineNumber}`}
                order={this.props.order}
                part={part}
                status={this.props.order.status}
                invoiceId={this.props.invoiceId}
                trackingNumbers={this.props.trackingNumbers}
                handleModalClicked={this.props.handleModalClicked}
              />
            ))}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default OrdersTableItem;
